/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ConnectivityState {
    /**
     * Device Ip offline (ping!)
     */ 
    Offline = 0,
    /**
     * Device Ip online (ping!)
     */ 
    Online = 1,
}
